import styles from './Label.module.scss';

const CustomCenteredLabel = ({ label }) => {
  return (
    <div className={styles.CustomLabel}>
      <label className={styles.CenteredLabel}>{label}</label>
    </div>
  )
}

export default CustomCenteredLabel;